export const baseURL = "https://api2.smartinb.ai";
// export const baseURL = "http://localhost:8002";
export const companyId = "68f0c33bb9f1ca87563ce4bc";
export const BrandsEndPoint = "/api/soonkitchen";
export const LabelsEndPoint = "/api/soonkitchenlabel";
export const RecipesEndPoint = "/api/soonkitchenrecipe";

// Menu EndPoints

export const MenuCategoriesEndPoint = "/api/menu-category";
export const MenuItemEndPoint = "/api/manufactorProduct";
